export default __webpack_public_path__ + "static/resumeEsp-badbaae94dc15361dd1f8e7c32635a5d.pdf";